// extracted by mini-css-extract-plugin
export default {"lazyLoader":"eE-z"};